/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Work_Plan_Status_CompletedInputs */



/**
* | output |
* | --- |
* | "Done" |
*
* @param {Chat_Work_Plan_Status_CompletedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_work_plan_status_completed = /** @type {((inputs?: Chat_Work_Plan_Status_CompletedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Work_Plan_Status_CompletedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erledigt")
	return /** @type {LocalizedString} */ ("Done")
});